module.exports = __webpack_public_path__ + "img/5-1.8908f911.png";